module.exports = __webpack_public_path__ + "static/media/empty.e0b5f43f.svg";